'use client'

import {
  createContext,
  type FC,
  type ReactNode,
  useContext,
  useMemo,
} from 'react'

import { type ProductOrderLimitConfig } from '../config/productOrderLimitPerTenantConfig'

type ProductOrderLimitContextValue = {
  config: ProductOrderLimitConfig
}

const ProductOrderLimitContext =
  createContext<ProductOrderLimitContextValue | null>(null)

export const ProductOrderLimitContextProvider: FC<{
  children: ReactNode
  config: ProductOrderLimitConfig
}> = ({ children, config }) => {
  const value = useMemo(() => {
    return { config }
  }, [config])

  return (
    <ProductOrderLimitContext.Provider value={value}>
      {children}
    </ProductOrderLimitContext.Provider>
  )
}

export const useProductOrderLimitContext =
  (): ProductOrderLimitContextValue => {
    const context = useContext(ProductOrderLimitContext)

    if (!context) {
      throw new Error('context_not_initialized')
    }

    return context
  }
